<script setup>
import LoadingCourseCard from './LoadingCourseCard.vue';
import { computed, defineProps } from 'vue';

const props = defineProps({
  showAssigned: {
    type: Boolean,
    default: true,
  },
  rows: {
    type: Number,
    default: 8,
  },
  data: {
    type: Array,
    default: () => [],
  },
  showCategories: {
    type: Boolean,
    default: true,
  }
})


const data = computed(() => props.data.length ? props.data : Array.from({ length: props.rows }));
</script>
<template>
  <div class="w-full" v-bind="$attrs">
    <ul role="list" class="grid grid-cols-1 gap-3 md:grid-cols-2">
      <LoadingCourseCard v-for="(item, index) in data" :key="index" :show-assigned="showAssigned" :show-categories="showCategories" :item="item" />
    </ul>
  </div>
</template>

<style lang="scss" scoped></style>
